import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,  // send httpOnly cookies with every request
});

// Auto-refresh on 401: POST /api/auth/token/refresh/ (browser sends refresh_token cookie)
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry) {
      original._retry = true;
      try {
        await axios.post('/api/auth/token/refresh/', {}, { withCredentials: true });
        return api(original);
      } catch {
        // Don't redirect if already on a public page - avoids hard-reload loops
        // caused by AuthContext's getMe() firing on page load.
        const pub = ['/login', '/register', '/invites/'];
        if (!pub.some(p => window.location.pathname.startsWith(p))) {
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
